import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { canSee, isAdmin, getViewAs, clearViewAs } from "../access";
import PreviewBar from "./PreviewBar";

// Gates a route to one or more audiences (admin always allowed). Shows a
// friendly locked screen otherwise, and a preview bar when an admin is previewing.
export default function AudienceGate({ allow, children, label = "this view" }) {
  const navigate = useNavigate();
  const ok = canSee(allow);
  const previewing = isAdmin() && getViewAs();

  if (ok) {
    return (<>{previewing && <PreviewBar />}{children}</>);
  }

  return (
    <div className="min-h-screen bg-slate-100" data-testid="audience-gate">
      {previewing && <PreviewBar />}
      <div className="mx-auto max-w-md px-5 py-24 text-center">
        <div className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
          <span className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-slate-900 text-white"><Lock className="h-5 w-5" /></span>
          <h1 className="font-display text-xl font-bold text-slate-900">Not part of {label}</h1>
          <p className="mt-2 text-sm text-slate-600">This section isn't included in your access. If you believe you should see it, please contact Aqualux Nexus.</p>
          {isAdmin() ? (
            <button data-testid="audience-gate-exit" onClick={() => { clearViewAs(); navigate("/admin/views"); }} className="mt-5 inline-flex items-center gap-2 rounded-full bg-slate-900 hover:bg-sky-700 text-white text-sm font-semibold px-5 py-2.5 transition-colors">
              Exit preview
            </button>
          ) : (
            <Link to="/" className="mt-5 inline-flex items-center rounded-full border border-slate-300 text-slate-700 text-sm font-semibold px-5 py-2.5 hover:bg-slate-50 transition-colors">Back to start</Link>
          )}
        </div>
      </div>
    </div>
  );
}
